import { connect } from 'react-redux';

import RegisterStep4Form from '../components/RegisterStep4Form';
import { createCognitoFormSkip } from '../../../../../state/modules/cognitoFormAnswers/actions';

const mapStateToProps = (state, ownProps) => {
  const profileId = state.session.get('profileId');

  return { profileId };
};

const mapDispatchToProps = (dispatch) => {
  return {
    create: (careGuideId, data, cb) => {
      dispatch(createCognitoFormSkip(careGuideId, data, cb));
    },
  };
};

const RegisterStep4FormContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(RegisterStep4Form);

export default RegisterStep4FormContainer;
